export default "__VITE_ASSET__Dh64jFeV__"